var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.049 8.422-2.373 7.33H9l-.59 1.808 6.214 4.53-2.374 7.332 1.54 1.116L20 26.011l6.21 4.527 1.54-1.116-2.374-7.332 6.213-4.53L31 15.752h-7.676l-2.373-7.33H19.05Zm-.694 8.638L20 11.977l1.645 5.083a1 1 0 0 0 .952.692h5.334l-4.319 3.15a1 1 0 0 0-.362 1.115l1.648 5.09-4.309-3.142a1 1 0 0 0-1.178 0l-4.309 3.142 1.648-5.09a1 1 0 0 0-.362-1.116l-4.32-3.15h5.335a1 1 0 0 0 .952-.691Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 20.23c0 9.39-7.611 17-17 17s-17-7.61-17-17c0-9.388 7.611-17 17-17s17 7.612 17 17Zm-2 0c0 8.285-6.716 15-15 15-8.284 0-15-6.715-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.330c7c5ed088378401afde8cf32a320e.svg";
export { ForwardRef as ReactComponent };